'use strict'
var existOverview = document.getElementsByClassName('burger');
if (existOverview.length > 0) {

    $(document).ready(function() {
        $('.slideshow__slick').slick({
            dots: true,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000
        });
    });


    const navSlide = () => {
        const burger = document.querySelector('.burger');
        const nav = document.querySelector('.nav-links');

        burger.addEventListener('click', () => {
            nav.classList.toggle('nav-active');
            burger.classList.toggle('toggle');
            linkanime.restart();
        });

    }

    navSlide();



    var linkanime = anime({
        targets: 'li',
        translateY: [{
                value: 0
            },
            {
                value: 30
            },
            {
                value: 0
            }

        ],
        opacity: [{
                value: 0
            },
            {
                value: 1
            }
        ],
        delay: function(el, i, l) {
            return i * 80
        },
        autoplay: false,
        easing: 'easeOutQuad'


    });


    anime({
        targets: 'img.letter',
        translateY: [{
                value: 200,
                duration: 250
            },
            {
                value: 0,
                duration: 300
            }
        ],
        scale: [{
                value: 0.5,
                duration: 250
            },
            {
                value: 1.2,
                duration: 300
            }
        ],
        opacity: [{
                value: 0,
                duration: 250
            },
            {
                value: 1.2,
                duration: 300
            }
        ],
        delay: function(el, i, l) {
            return i * 235
        },
        loop: true

    });



};
var existOverview = document.getElementsByClassName('modal');
if (existOverview.length > 0) {

    const modal = document.querySelector('#my-modal');
    const modal2 = document.querySelector('#my-modal-pres');
    const modalBtn = document.querySelector('.button');
    const closeBtn = document.querySelector('.close');
    const animation = document.querySelector('.container');
    const over = document.querySelector('#over');
    const win1 = document.querySelector('#win1');
    const win2 = document.querySelector('#win2');
    const win3 = document.querySelector('#win3');
    const win4 = document.querySelector('#win4');
    const win5 = document.querySelector('#win5');

    var click = 0;
    var outOfTime = false;
    var time = 60 * 2;
    over.addEventListener("click", function(event) {
        if (event.currentTarget.getAttribute("data-disable") == 1) {
            return;
        }
        event.currentTarget.setAttribute("data-disable", 1);

        disnone.play()

        var timer = setInterval(function() {
            time--;
            document.getElementById("timer").innerHTML = time + "s";
            if (time == 0) {
                clearInterval(timer);
                modal.style.display = 'block';
                anime.restart;
                outOfTime = true;
            } else if (click == 5) {
                clearInterval(timer);
                animation.style.display = 'block';
                anim1.play();
                anim2.play();
                anim3.play();
                anim4.play();
                anim5.play();
                anim6.play();

                setTimeout(function() {
                    animation.style.display = 'none';
                }, 2500);

                setTimeout(function() {
                    modalBtn.style.display = 'block';
                    modal2.style.display = 'block';
                }, 2500);

                outOfTime = true;
            }
        }, 1000);


        let fooElement01 = document.querySelector("#error1");
        fooElement01.addEventListener("click", (event) => {


            if (event.currentTarget.getAttribute("data-disable") == 1) {
                return;
            }

            if (!outOfTime) {
                click += 1;
                win1.style.display = 'block';
                document.getElementById("score").innerHTML = 'erreurs = ' + click;
            }
            event.currentTarget.setAttribute("data-disable", 1);

        });


        let fooElement02 = document.querySelector("#error2");
        fooElement02.addEventListener("click", (event) => {

            if (event.currentTarget.getAttribute("data-disable") == 1) {
                return;
            }

            if (!outOfTime) {
                click += 1;
                win2.style.display = 'block';

                document.getElementById("score").innerHTML = 'erreurs = ' + click;
                event.currentTarget.setAttribute("data-disable", 1);
            }

        });


        let fooElement03 = document.querySelector("#error3");
        fooElement03.addEventListener("click", (event) => {

            if (event.currentTarget.getAttribute("data-disable") == 1) {
                return;
            }

            if (!outOfTime) {
                click += 1;
                win4.style.display = 'block';
                document.getElementById("score").innerHTML = 'erreurs = ' + click;

            }
            event.currentTarget.setAttribute("data-disable", 1);

        });


        let fooElement04 = document.querySelector("#error4");
        fooElement04.addEventListener("click", (event) => {

            if (event.currentTarget.getAttribute("data-disable") == 1) {
                return;
            }

            if (!outOfTime) {
                click += 1;
                win5.style.display = 'block';
                document.getElementById("score").innerHTML = 'erreurs = ' + click;
            }
            event.currentTarget.setAttribute("data-disable", 1);

        });

        let fooElement05 = document.querySelector("#error5");
        fooElement05.addEventListener("click", (event) => {

            if (event.currentTarget.getAttribute("data-disable") == 1) {
                return;
            }

            if (!outOfTime) {
                click += 1;
                win3.style.display = 'block';
                document.getElementById("score").innerHTML = 'erreurs = ' + click;
            }
            event.currentTarget.setAttribute("data-disable", 1);

        });
    });


    // Events
    modalBtn.addEventListener('click', openModal);
    closeBtn.addEventListener('click', closeModal);
    window.addEventListener('click', outsideClick);

    // Open
    function openModal() {
        modal2.style.display = 'block';
    }

    // Close
    function closeModal() {
        modal2.style.display = 'none';
    }

    // Close If Outside Click
    function outsideClick(e) {
        if (e.target == modal2) {
            modal2.style.display = 'none';
        }
    }




    anime({
        targets: '#phone',
        rotate: [{
                value: 0
            },
            {
                value: -90,
                duration: 1000
            }
        ],
        loop: true
    });

    var disnone = anime({
        targets: '#disnone',
        translateX: [{
                value: 0
            },
            {
                value: -500,
                duration: 2300
            }
        ],
        easing: 'easeInOutQuint',
        autoplay: false

    });


    var anim1 = anime({
        targets: 'img.box',
        translateY: [{
                value: 200,
                duration: 250
            },
            {
                value: 0,
                duration: 300
            }
        ],
        scale: [{
                value: 0.5,
                duration: 250
            },
            {
                value: 1.2,
                duration: 300
            }
        ],
        opacity: [{
                value: 0,
                duration: 250
            },
            {
                value: 1.2,
                duration: 300
            }
        ],
        delay: function(el, i, l) {
            return i * 235
        },
        autoplay: false


    });

    var anim2 = anime({
        targets: 'path.st4',
        d: [{
                value: 'M103.92,82.48H14.56C6.55,82.48,0,75.93,0,67.92l0-14.4c0-8.01,6.55-14.56,14.56-14.56h89.36c8.01,0,14.56,6.55,14.56,14.56v14.4C118.48,75.93,111.93,82.48,103.92,82.48z'
            },
            {
                value: 'M105.96,70.39H12.52C5.64,70.39,0,64.76,0,57.87l0-1.01c0-6.89,5.64-12.52,12.52-12.52h93.43c6.89,0,12.52,5.64,12.52,12.52v1.01C118.48,64.76,112.84,70.39,105.96,70.39z'
            },
            {
                value: 'M103.92,82.48H14.56C6.55,82.48,0,75.93,0,67.92l0-14.4c0-8.01,6.55-14.56,14.56-14.56h89.36c8.01,0,14.56,6.55,14.56,14.56v14.4C118.48,75.93,111.93,82.48,103.92,82.48z'
            },
            {
                value: 'M105.96,70.39H12.52C5.64,70.39,0,64.76,0,57.87l0-1.01c0-6.89,5.64-12.52,12.52-12.52h93.43c6.89,0,12.52,5.64,12.52,12.52v1.01C118.48,64.76,112.84,70.39,105.96,70.39z'
            },
            {
                value: 'M103.92,82.48H14.56C6.55,82.48,0,75.93,0,67.92l0-14.4c0-8.01,6.55-14.56,14.56-14.56h89.36c8.01,0,14.56,6.55,14.56,14.56v14.4C118.48,75.93,111.93,82.48,103.92,82.48z'
            },
            {
                value: 'M105.96,70.39H12.52C5.64,70.39,0,64.76,0,57.87l0-1.01c0-6.89,5.64-12.52,12.52-12.52h93.43c6.89,0,12.52,5.64,12.52,12.52v1.01C118.48,64.76,112.84,70.39,105.96,70.39z'
            },
        ],
        easing: 'easeOutQuad',
        duration: 1500,
        autoplay: false
    });

    var anim3 = anime({
        targets: 'path.st6',
        d: [{
                value: 'M91.81,29.63H25.67c-4.96,0-9.02-4.06-9.02-9.02V9.02c0-4.96,4.06-9.02,9.02-9.02l66.15,0c4.96,0,9.02,4.06,9.02,9.02v11.6C100.83,25.57,96.77,29.63,91.81,29.63z'
            },
            {
                value: 'M91.81,20.34H25.67c-4.96,0-9.02-4.06-9.02-9.02V9.02c0-4.96,4.06-9.02,9.02-9.02l66.15,0c4.96,0,9.02,4.06,9.02,9.02v2.31C100.83,16.28,96.77,20.34,91.81,20.34z'
            },
            {
                value: 'M91.81,29.63H25.67c-4.96,0-9.02-4.06-9.02-9.02V9.02c0-4.96,4.06-9.02,9.02-9.02l66.15,0c4.96,0,9.02,4.06,9.02,9.02v11.6C100.83,25.57,96.77,29.63,91.81,29.63z'
            },
            {
                value: 'M91.81,20.34H25.67c-4.96,0-9.02-4.06-9.02-9.02V9.02c0-4.96,4.06-9.02,9.02-9.02l66.15,0c4.96,0,9.02,4.06,9.02,9.02v2.31C100.83,16.28,96.77,20.34,91.81,20.34z'
            },
            {
                value: 'M91.81,29.63H25.67c-4.96,0-9.02-4.06-9.02-9.02V9.02c0-4.96,4.06-9.02,9.02-9.02l66.15,0c4.96,0,9.02,4.06,9.02,9.02v11.6C100.83,25.57,96.77,29.63,91.81,29.63z'
            },
            {
                value: 'M91.81,20.34H25.67c-4.96,0-9.02-4.06-9.02-9.02V9.02c0-4.96,4.06-9.02,9.02-9.02l66.15,0c4.96,0,9.02,4.06,9.02,9.02v2.31C100.83,16.28,96.77,20.34,91.81,20.34z'
            },
        ],
        easing: 'easeOutQuad',
        duration: 1500

    });

    var anim4 = anime({
        targets: '#ombre_visage',
        translateY: [{
                value: -15,
                duration: 220
            },
            {
                value: 0,
                duration: 220
            },
            {
                value: -15,
                duration: 220
            },
            {
                value: 0,
                duration: 220
            },
            {
                value: -15,
                duration: 310
            },
        ],
        easing: 'easeOutQuad',
        delay: 305,
        autoplay: false
    });


    var anim5 = anime({
        targets: '#pomme',
        translateY: [{
            value: -150,
            duration: 500
        }, ],
        easing: 'easeOutQuad',
        loop: false,
        delay: 340,
        autoplay: false
    });

    var anim6 = anime({
        targets: '.persoanim',
        scale: [{
            value: 1.5,
            duration: 500
        }, ],
        opacity: [{
            value: 1,
            duration: 500
        }, ],
        easing: 'easeOutQuad',
        loop: false,
        delay: 200,
        autoplay: false

    });



}